// ============================================================================
// SN-Link Protocol — Packet Builder & Response Parser (stub)
// ============================================================================
//
// Protocol details must be confirmed via Wireshark captures from
// the official SN-Link ISP tool. The layout below is estimated from
// the SN-Link ISP User Guide command opcodes.

import { SnLinkCmd, SNLINK_REPORT_SIZE } from './constants';

/**
 * Build an SN-Link command packet.
 *
 * Estimated packet layout (64 bytes):
 *   [0]    Command opcode
 *   [1]    Sub-command / flags
 *   [2-3]  Address (LE 16-bit)
 *   [4-5]  Length (LE 16-bit)
 *   [6]    Reserved
 *   [7]    Reserved
 *   [8+]   Data payload
 */
export function buildPacket(
  cmd: SnLinkCmd,
  params: {
    subCmd?: number;
    address?: number;
    length?: number;
    data?: Uint8Array;
  } = {}
): Uint8Array {
  const packet = new Uint8Array(SNLINK_REPORT_SIZE);
  const view = new DataView(packet.buffer);

  packet[0] = cmd;
  packet[1] = params.subCmd ?? 0;
  view.setUint16(2, params.address ?? 0, true);  // LE
  view.setUint16(4, params.length ?? 0, true);    // LE

  if (params.data && params.data.length > 0) {
    const maxData = SNLINK_REPORT_SIZE - 8;
    packet.set(params.data.subarray(0, maxData), 8);
  }

  return packet;
}

/**
 * Parse an SN-Link response packet.
 */
export function parseResponse(
  data: Uint8Array,
  _cmd: SnLinkCmd
): { status: number; payload: Uint8Array; param1: number; param2: number } {
  const view = new DataView(data.buffer, data.byteOffset, data.byteLength);

  return {
    status: data[0],
    payload: data.subarray(8),
    param1: view.getUint16(2, true),
    param2: view.getUint16(4, true),
  };
}
